import type React from 'react'
import { GripVertical, Loader2, Sparkles, X } from 'lucide-react'
import { Button } from '@components/ui/button'
import { cn } from '@/utils'

/** Title row: drag grabber, "Photo Effects" with a busy spinner, and Close. */
export function PhotoEffectsHeader({
  isDragging,
  showBusy,
  onDragStart,
  onDragMove,
  onDragEnd,
  onClose,
}: {
  isDragging: boolean
  showBusy: boolean
  onDragStart: (e: React.PointerEvent<HTMLButtonElement>) => void
  onDragMove: (e: React.PointerEvent<HTMLButtonElement>) => void
  onDragEnd: (e: React.PointerEvent<HTMLButtonElement>) => void
  onClose: () => void
}) {
  return (
    <div className="flex h-8 w-full flex-row items-start" style={{ gap: 16 }}>
      <button
        type="button"
        aria-label="Move Photo Effects"
        data-photo-effects-grabber
        onPointerDown={onDragStart}
        onPointerMove={onDragMove}
        onPointerUp={onDragEnd}
        onPointerCancel={onDragEnd}
        className={cn(
          'touch-none flex h-8 w-6 shrink-0 items-center justify-center border-none bg-transparent p-0 text-[#737373]',
          isDragging ? 'cursor-grabbing' : 'cursor-grab'
        )}
      >
        <GripVertical className="size-6" strokeWidth={2} aria-hidden="true" />
      </button>

      <div className="flex h-8 min-w-0 flex-1 flex-row items-center">
        <Sparkles className="size-6 shrink-0 text-[#1E1902]" strokeWidth={2} aria-hidden="true" />
        <div className="flex h-8 flex-col items-start px-2 py-1.5">
          <h2 className="text-sm font-semibold leading-5 text-[#1E1902]">Photo Effects</h2>
        </div>
        {showBusy ? (
          <Loader2 className="size-4 shrink-0 animate-spin text-[#737373]" aria-hidden="true" />
        ) : null}
      </div>

      <Button
        type="button"
        variant="ghost"
        size="icon"
        className="size-8 shrink-0 rounded-lg p-0 text-[#1E1902] hover:bg-transparent hover:text-[#1E1902]"
        aria-label="Close"
        onClick={onClose}
      >
        <X className="size-4" strokeWidth={1.33} aria-hidden="true" />
      </Button>
    </div>
  )
}
